import React from "react";
import {NavLink}  from 'react-router-dom';
import logo from "./images/coffee7.jpg"
var logoStyle ={
width:"100px",
height:"30px",
top:"20px",
borderRadius:"50%",
position:"fixed"


}


function Navbar(){
  return (
      <>
   
   
   <div className="header title">COFFEE-CORNER</div>
   <div className="navb  navcust">
   <span className="bars"  onClick={OpenSlide}>&equiv;</span>
     <NavLink exact to ="/"   >Home</NavLink> 
     <NavLink exact to ="/coffee-shop">Coffee_Shop</NavLink>
     <NavLink exact to ="/about">About</NavLink>
     <NavLink exact to ="/contact">Contact</NavLink>
     <span className="coffeelogo"> <img  src={logo} alt="coffee"  style={logoStyle} /></span> 
    
   </div>
   
   <div className="sidebar sidecust">
      <span className="cross" onClick={CloseSlide} >&times;</span>
      <NavLink exact to ="/" onClick={CloseSlide}   >Home</NavLink> 
     <NavLink exact to ="/coffee-shop"  onClick={CloseSlide}>Coffee_Shop</NavLink>
     <NavLink exact to ="/about"  onClick={CloseSlide}>About</NavLink>
     <NavLink exact to ="/contact" onClick={CloseSlide}>Contact</NavLink> 
   </div>
  
   
     </> 
  )

  
  function OpenSlide(){
      if(window.screen.width > 799){
     document.querySelector(".sidebar").style.width="0px";      
                }else{
       document.querySelector(".sidebar").style.width="300px";                                          
                }
  
      
  }
  
  
   function CloseSlide(){
  document.querySelector(".sidebar").style.width="0px";    
      }  
  
}



 
 
 export default Navbar;